// Copyright (c) 2026 Roy Liu. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary
/**
 * #1621: the trading screens' Chinese words (i18n.dict.nmo.ts, ~290 KB) as a loader core can call, so they are fetched
 * only when Chinese is needed (src/web/i18n.ts `registerWordsLoader`). The file registers its words when it arrives.
 * Without this plugin the build gives core a loader that loads nothing (scripts/build-web.mjs).
 */
export const loadPluginWords = (): Promise<unknown> => import("./i18n.dict.nmo.ts");
